/* eslint-disable no-useless-escape */
import CryptoJS from 'crypto-js';
import { ENCRYPT_KEY } from 'enviroments';
import isEmpty from 'lodash/isEmpty';
import { some } from 'types';

export const encryptUtils = (input, key: any = ENCRYPT_KEY) => {
  key = CryptoJS.enc.Latin1.parse(key);
  const encrypted = CryptoJS.AES.encrypt(input, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
};

export const decryptUtils = (input: string, key: string) => {
  const enKey = CryptoJS.enc.Latin1.parse(key);
  const bytes = CryptoJS.AES.decrypt(input, enKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  const originalText = bytes.toString(CryptoJS.enc.Utf8);

  return originalText && JSON.parse(originalText);
};

export const roundNumber = (num, degits) => {
  const number = parseFloat(num);
  if (Number.isNaN(number)) return;

  return number.toFixed(degits);
};

export const changeToSlug = (title) => {
  let slug = '';

  if (!title) {
    return slug;
  }

  slug = title.toLowerCase();

  slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
  slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
  slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
  slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
  slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
  slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
  slug = slug.replace(/đ/gi, 'd');

  slug = slug.replace(
    /\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi,
    ''
  );

  slug = slug.replace(/ /gi, '-');

  slug = slug.replace(/\-\-\-\-\-/gi, '-');
  slug = slug.replace(/\-\-\-\-/gi, '-');
  slug = slug.replace(/\-\-\-/gi, '-');
  slug = slug.replace(/\-\-/gi, '-');
  slug = '@' + slug + '@';
  slug = slug.replace(/\@\-|\-\@|\@/gi, '');

  return slug;
};

export const combineUrlParams = (url = '', params: object = {}) => {
  if (isEmpty(params)) {
    return url;
  }

  const keys = Object.keys(params);
  const paramUrl = keys
    .reduce((result: string[], key) => {
      const keyObj = params[key];

      return keyObj !== undefined && keyObj !== null && keyObj !== ''
        ? [...result, `${key}=${keyObj}`]
        : [...result];
    }, [])
    .join('&');
  return `${url}?${paramUrl}`;
};

export function listToTreeCategories(dataset) {
  const hashTable = Object.create(null);
  dataset.forEach((aData) => (hashTable[aData.id] = { ...aData, children: [] }));
  const dataTree: some[] = [];
  dataset.forEach((aData) => {
    if (aData.parent_id && hashTable[aData.parent_id])
      hashTable[aData.parent_id].children?.push(hashTable[aData.id]);
    else dataTree.push(hashTable[aData.id]);
  });
  return dataTree;
}
